/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - David Pistori <dp@indigen.com>
 *   - Loay Hatem <lh@indigen.com>
 *   - Peter Magdy <pm@indigen.com>
 * NOTICE: All information contained here is, and remains
 * the property of Indigen Solutions and its suppliers, if any.
 *
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import * as React from "react";
import Logo from "../Logo/Logo";
import RedLem from "./lems/RedLem";
import RedOutlinedLem from "./lems/RedOutlinedLem";

export interface OnBoardingFirstScreenProps {
  startScreens: boolean;
}

export interface OnBoardingFirstScreenState {
  activeIndex: number;
}

export default class OnBoardingFirstScreen extends React.Component<
  OnBoardingFirstScreenProps,
  OnBoardingFirstScreenState
> {
  constructor(props: OnBoardingFirstScreenProps) {
    super(props);
    this.state = {
      activeIndex: 0,
    };
  }

  public componentDidMount() {}

  render() {
    return (
      <div
        className={`onBoardingFirstScreen ${
          !this.props.startScreens ? "active" : ""
        }`}
      >
        <div className={"onBoardingTopLem"}>
          <RedLem />
        </div>

        <div className={"welcomeLogo"}>
          <Logo />
          <div className={"text"}>Bienvenue sur votre espace.</div>
        </div>

        <div className={"onBoardingBottomLem"}>
          <RedOutlinedLem />
        </div>
      </div>
    );
  }
}
